/* Dopekicks cart discount box: apply / remove codes instantly via the Cart AJAX API,
   then re-render the cart drawer and/or cart page so totals and savings update.
   When the Buy More Save More engine (assets/dk-bmsm.js -> window.DKBM) is loaded, codes go through it
   so the cart always keeps whichever discount saves the customer more. */
(function () {
  if (customElements.get('dk-cart-coupon')) return;

  var T = {
    empty: 'Enter a discount code',
    invalid: '"{code}" isn’t valid for the items in your cart',
    ok: '{code} applied — your savings are shown below',
    okAmt: '{code} applied — you save {amt}',
    better: 'You already have a better deal: {best} saves you {amt}. {code} wasn’t applied.',
    already: '{code} is already applied',
    removed: 'Code removed',
    error: 'Something went wrong. Please try again.'
  };

  function post(discount) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discount })
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }

  function pick(html, sel) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
  }

  function clearStored() {
    document.cookie = 'discount_code=; path=/; max-age=0';
    try { localStorage.removeItem('dk_coupon'); localStorage.removeItem('coupon'); sessionStorage.removeItem('dk_coupon_hide'); } catch (e) {}
    var badge = document.querySelector('.dk-coupon');
    if (badge) badge.remove();
  }

  /* Re-render everything that shows cart totals */
  function refresh() {
    if (window.DKBM) return window.DKBM.refresh();
    var jobs = [];
    var drawer = document.getElementById('mini-cart-drawer');
    if (drawer) {
      jobs.push(fetch('/?sections=mini-cart-drawer').then(function (r) { return r.json(); }).then(function (j) {
        var el = j['mini-cart-drawer'] && pick(j['mini-cart-drawer'], '.shopify-section');
        if (el) drawer.innerHTML = el.innerHTML;
      }));
    }
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && footer && items.dataset.id && footer.dataset.id) {
      var ids = [items.dataset.id, footer.dataset.id];
      jobs.push(fetch('/cart?sections=' + ids.join(',')).then(function (r) { return r.json(); }).then(function (j) {
        [[items, ids[0]], [footer, ids[1]]].forEach(function (p) {
          var fresh = j[p[1]] && pick(j[p[1]], '.js-contents');
          var cur = p[0].querySelector('.js-contents');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
      }));
    }
    return Promise.all(jobs);
  }

  /* After a re-render the box is a new element: show the message on every coupon box on the page */
  function sayAll(text, type, keepCode) {
    document.querySelectorAll('dk-cart-coupon').forEach(function (el) {
      if (el.say) el.say(text, type);
      if (keepCode && el.input) el.input.value = keepCode;
    });
    if (type === 'ok') {
      document.querySelectorAll('.dkcs__save').forEach(function (el) {
        el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
      });
    }
  }

  customElements.define('dk-cart-coupon', class extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      this.input = this.querySelector('.dkcc__input');
      this.btn = this.querySelector('.dkcc__apply');
      this.msg = this.querySelector('.dkcc__msg');
      var self = this;
      this.btn.addEventListener('click', function () { self.apply(); });
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); self.apply(); }
      });
      this.input.addEventListener('input', function () { self.msg.hidden = true; });
      /* keep the drawer's quantity listener from treating our input as a qty change */
      this.addEventListener('change', function (e) { e.stopPropagation(); });
      this.addEventListener('click', function (e) {
        var x = e.target.closest('[data-dkcc-remove]');
        if (x) { e.preventDefault(); e.stopPropagation(); self.remove(x.getAttribute('data-dkcc-remove')); }
      });
      var flash = null;
      try { flash = sessionStorage.getItem('dkcc_flash'); } catch (e) {}
      if (flash) {
        try { sessionStorage.removeItem('dkcc_flash'); } catch (e) {}
        this.say(flash, 'ok');
        document.querySelectorAll('.dkcs__save').forEach(function (el) {
          el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
        });
      }
    }

    codes() { return (this.dataset.codes || '').split(',').filter(Boolean); }

    say(text, type) {
      this.msg.textContent = text;
      this.msg.className = 'dkcc__msg dkcc__msg--' + type;
      this.msg.hidden = false;
    }

    busy(on) {
      this.classList.toggle('is-busy', on);
      this.btn.disabled = on;
      this.input.disabled = on;
    }

    apply() {
      var self = this;
      var code = this.input.value.trim();
      if (!code) { this.say(T.empty, 'err'); this.input.focus(); return; }
      var cur = this.codes();
      var lc = code.toLowerCase();
      if (cur.some(function (c) { return c.toLowerCase() === lc; })) {
        this.say(T.already.replace('{code}', code.toUpperCase()), 'ok');
        return;
      }
      this.busy(true);

      if (window.DKBM) {
        var B = window.DKBM, CODE = code.toUpperCase();
        B.applyUserCode(code).then(function (res) {
          var r = res.result || {}, cur$ = r.cart && r.cart.currency;
          self.busy(false);
          if (res.status === 'applied') {
            document.dispatchEvent(new CustomEvent('dk:cart-discount', { detail: r.cart }));
            sayAll(T.okAmt.replace('{code}', CODE).replace('{amt}', B.money(r.userSaving, cur$)), 'ok');
          } else if (res.status === 'worse') {
            var best = r.tier ? r.tier.title : String(r.winner || '').toUpperCase();
            var amt = B.money(r.kind === 'tier' ? r.tierSaving : r.userSaving, cur$);
            sayAll(T.better.replace('{best}', best).replace('{amt}', amt).replace('{code}', CODE), 'ok');
          } else {
            sayAll(T.invalid.replace('{code}', CODE), 'err', code);
          }
        }).catch(function () {
          self.busy(false);
          sayAll(T.error, 'err', code);
        });
        return;
      }

      post(cur.concat(code).join(',')).then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === lc; })[0];
        if (hit && hit.applicable) {
          var okMsg = T.ok.replace('{code}', hit.code.toUpperCase());
          try { sessionStorage.setItem('dkcc_flash', okMsg); } catch (e) {}
          document.dispatchEvent(new CustomEvent('dk:cart-discount', { detail: cart }));
          return refresh().then(function () {
            if (self.isConnected) {
              try { sessionStorage.removeItem('dkcc_flash'); } catch (e) {}
              self.busy(false);
              self.say(okMsg, 'ok');
            }
          });
        }
        /* Not valid: roll the cart back to the codes it had before, keep the input so they can fix it */
        return post(cur.join(',')).then(function () {
          self.busy(false);
          self.say(T.invalid.replace('{code}', code.toUpperCase()), 'err');
          self.input.focus(); self.input.select();
        });
      }).catch(function () {
        self.busy(false);
        self.say(T.error, 'err');
      });
    }

    remove(code) {
      var self = this;
      var lc = String(code).toLowerCase();
      this.busy(true);

      if (window.DKBM) {
        clearStored();
        window.DKBM.removeCode(code).then(function () {
          self.busy(false);
          sayAll(T.removed, 'ok');
        }).catch(function () {
          self.busy(false);
          sayAll(T.error, 'err');
        });
        return;
      }

      var rest = this.codes().filter(function (c) { return c.toLowerCase() !== lc; });
      try { sessionStorage.setItem('dkcc_flash', T.removed); } catch (e) {}
      post(rest.join(',')).then(function () {
        if (!rest.length) clearStored();
        return refresh();
      }).then(function () {
        if (self.isConnected) {
          try { sessionStorage.removeItem('dkcc_flash'); } catch (e) {}
          self.busy(false); self.say(T.removed, 'ok');
        }
      }).catch(function () {
        try { sessionStorage.removeItem('dkcc_flash'); } catch (e) {}
        self.busy(false);
        self.say(T.error, 'err');
      });
    }
  });
})();
